import { IconSize } from '@getaccept/fried-tofu';
import { defineComponent, ref } from 'vue';
import VideoPlayer from './VideoPlayer.vue';
export default defineComponent({
    components: {
        VideoPlayer,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
        thumbUrl: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
    },
    emits: ['close', 'trackVideo'],
    setup(props, { emit }) {
        const currentVideoPlayTime = ref(null);
        const handleClose = () => {
            sendTrackingData();
            emit('close');
        };
        const handleTimeUpdate = (playtime) => {
            currentVideoPlayTime.value = playtime;
        };
        const handlePause = () => {
            sendTrackingData();
        };
        const handleEnded = () => {
            sendTrackingData();
        };
        const sendTrackingData = () => {
            if (!currentVideoPlayTime.value) {
                return;
            }
            emit('trackVideo', { id: props.id, viewDuration: currentVideoPlayTime.value });
            currentVideoPlayTime.value = null;
        };
        return {
            IconSize,
            currentVideoPlayTime,
            handleClose,
            handleTimeUpdate,
            handlePause,
            handleEnded,
            sendTrackingData,
        };
    },
});
